module.exports = __webpack_public_path__ + "static/media/filled_bar_M1.0bfcb5c1.svg";